var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5548 7.49023C13.4129 7.49023 12.4839 8.41928 12.4839 9.56122C12.4839 10.703 13.4129 11.632 14.5548 11.632C15.697 11.632 16.6258 10.703 16.6258 9.56122C16.6258 8.41928 15.6968 7.49023 14.5548 7.49023ZM14.5548 10.4705C14.0532 10.4705 13.6452 10.0625 13.6452 9.56101C13.6452 9.05933 14.0532 8.65134 14.5548 8.65134C15.0565 8.65134 15.4645 9.05954 15.4645 9.56101C15.4645 10.0625 15.0565 10.4705 14.5548 10.4705Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5742 0H0.580642C0.259946 0 0 0.259946 0 0.580677V9.52262C0 9.84332 0.259946 10.1033 0.580642 10.1033H2.40002V8.94198H1.16128V1.16132H10.9936V9.52262H12.1548V0.580677C12.1549 0.259946 11.8949 0 11.5742 0Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0645 8.94141H5.24512V10.1027H13.0645V8.94141Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81269 7.49023C2.67074 7.49023 1.7417 8.41928 1.7417 9.56122C1.7417 10.703 2.67074 11.632 3.81269 11.632C4.95464 11.632 5.88368 10.703 5.88368 9.56122C5.88364 8.41928 4.95464 7.49023 3.81269 7.49023ZM3.81269 10.4705C3.31101 10.4705 2.90302 10.0625 2.90302 9.56101C2.90302 9.05933 3.31101 8.65134 3.81269 8.65134C4.31437 8.65134 4.72236 9.05954 4.72236 9.56101C4.72236 10.0625 4.31416 10.4705 3.81269 10.4705Z",
    fill: "#383838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4189 4.81836H11.5737V5.97964H16.8382V8.94093H16.006V10.1022H17.4189C17.7396 10.1022 17.9995 9.84248 17.9995 9.52157V5.399C17.9996 5.07831 17.7396 4.81836 17.4189 4.81836Z",
    fill: "#383838"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6633 2.41014C15.5613 2.22472 15.3661 2.10938 15.1544 2.10938H11.5737V3.27066H14.811L16.1359 5.67957L17.1535 5.11981L15.6633 2.41014Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryCar);
export default __webpack_public_path__ + "static/media/deliveryCar.7f95a358ecfaab57c3835724405dd3a1.svg";
export { ForwardRef as ReactComponent };